<app-back-header 
  [headerText]="'Torna alla dashboard'" 
  (backAction)="backToDashboard()" 
  class="sticky-top">
</app-back-header>

<!-- File input -->
<div class="file-input-section">
  <input 
    type="file" 
    (change)="onFileSelected($event)" 
    accept=".xlsx,.xls" 
    class="file-input"
    #fileInput
  />
  <button type="button" (click)="fileInput.click()" class="btn btn-outline-primary">
    Choose Excel File
  </button>
  
  <div *ngIf="selectedFile" class="file-info">
    <strong>Selected file:</strong> {{ selectedFile.name }}
    <br>
    <small>Size: {{ formatFileSize(selectedFile.size) }}</small>
  </div>
</div>

<!-- Excel Preview -->
<div *ngIf="excelPreview" class="excel-preview">
  <h5>Excel File Preview</h5>
  
  <div class="preview-info">
    <p><strong>Sheet:</strong> {{ excelPreview.sheetName }}</p>
    <p><strong>Total Rows:</strong> {{ excelPreview.totalRows }}</p>
    <p><strong>Total Sheets:</strong> {{ excelPreview.totalSheets }}</p>
  </div>

  <!-- Column Mapping Suggestions -->
  <div *ngIf="getColumnMappingSuggestions()" class="mapping-suggestions">
    <h6>Detected Column Mappings:</h6>
    <ul>
      <li *ngFor="let suggestion of getColumnMappingSuggestions() | keyvalue">
        <strong>{{ suggestion.key }}</strong> → {{ suggestion.value }}
      </li>
    </ul>
  </div>

  <!-- Data Preview Table -->
  <div class="table-responsive">
    <table class="table table-sm table-bordered">
      <thead>
        <tr>
          <th *ngFor="let header of excelPreview.headers" class="bg-light">
            {{ header }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of excelPreview.sampleData">
          <td *ngFor="let cell of row">
            {{ cell }}
          </td>
        </tr>
      </tbody>
    </table>
    <small class="text-muted">Showing first 5 rows</small>
  </div>
</div>

<!-- Upload Progress -->
<div *ngIf="isUploading" class="upload-progress">
  <div class="progress">
    <div 
      class="progress-bar" 
      [style.width]="uploadProgress + '%'"
    >
      {{ uploadProgress }}%
    </div>
  </div>
  <p>Uploading and processing companies...</p>
</div>

<!-- Upload Result -->
<div *ngIf="uploadResult" class="upload-result alert alert-success">
  <h6>Import Successful!</h6>
  <p><strong>Imported:</strong> {{ uploadResult.imported_count }} companies</p>
  <p *ngIf="uploadResult.failed_count > 0">
    <strong>Failed:</strong> {{ uploadResult.failed_count }} rows
  </p>
  <div *ngIf="uploadResult.failed_rows?.length" class="failed-rows">
    <strong>Failed rows:</strong>
    <ul>
      <li *ngFor="let failed of uploadResult.failed_rows">{{ failed }}</li>
    </ul>
  </div>
</div>

<!-- Error Message -->
<div *ngIf="uploadError" class="alert alert-danger">
  {{ uploadError }}
</div>

<!-- Upload Button -->
<button 
  type="button" 
  (click)="onSubmit()" 
  [disabled]="!selectedFile || isUploading"
  class="btn btn-primary"
>
  <span *ngIf="isUploading" class="spinner-border spinner-border-sm me-2"></span>
  {{ isUploading ? 'Uploading...' : 'Upload Companies' }}
</button>
